/**
 * Yeppon Warranty Upsell Popup v4
 * 
 * Seleziona automaticamente la garanzia corretta in base al prezzo del prodotto.
 * Caricamento PDP solo se il prodotto ha il tag warranty-upsell (vedi warranty-upsell.liquid).
 * 
 * Desktop: pannello centrato a due colonne
 * Mobile:  bottom sheet con swipe-to-dismiss
 * 
 * Configurazione iniettata da Liquid come window.__warrantyConfig
 */

(function() {
  'use strict';

  var config = window.__warrantyConfig;
  if (!config || !config.tiers || config.tiers.length === 0) return;

  var settings = config.settings || {};
  var accentColor = settings.accent_color || '#0b5d1e';
  var accentEnd = settings.accent_end || '#148a32';
  var priceColor = settings.price_color || '#c62828';
  var priceLeadColor = settings.price_lead_color || '#555555';
  var featureTitleColor = settings.feature_title_color || '#1a1a1a';
  var ctaFg = settings.cta_text_color || '#ffffff';
  var ctaFill = settings.cta_background
    ? settings.cta_background
    : 'linear-gradient(135deg,' + accentColor + ',' + accentEnd + ')';
  var MOBILE_BP = 768;
  var isMobile = function() { return window.innerWidth < MOBILE_BP; };

  // Tema Hyper: aggiorna prezzo quando cambia variante (product-info / variant-selects)
  function syncPriceFromVariant(variant) {
    if (!variant || variant.price == null) return;
    var cents = parseFloat(variant.price);
    if (!isNaN(cents) && cents > 0) window.__warrantyProductPrice = cents / 100;
  }
  var wuVariantPubsubDone = false;
  function attachVariantPubsub() {
    if (wuVariantPubsubDone) return;
    if (!(window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS)) return;
    wuVariantPubsubDone = true;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function(ev) {
      syncPriceFromVariant(ev && ev.data && ev.data.variant);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachVariantPubsub);
  } else {
    attachVariantPubsub();
  }
  setTimeout(attachVariantPubsub, 100);
  document.addEventListener('variant:changed', function(ev) {
    syncPriceFromVariant(ev.detail && ev.detail.variant);
  });

  // Ordina fasce per max_price crescente
  var tiers = config.tiers.slice().sort(function(a, b) { return a.max_price - b.max_price; });

  // Trova garanzia per prezzo prodotto
  function findTier(price) {
    for (var i = 0; i < tiers.length; i++) {
      if (price <= tiers[i].max_price) return tiers[i];
    }
    return null;
  }

  // Prodotti esclusi
  var excludedTypes = (config.excluded_product_types || []).map(function(t) { return t.toLowerCase(); });
  var warrantyVariantIds = new Set(tiers.map(function(t) { return String(t.variant_id); }));

  function isExcluded(productType, variantId) {
    if (warrantyVariantIds.has(String(variantId))) return true;
    if (!productType) return false;
    var pt = productType.toLowerCase();
    for (var i = 0; i < excludedTypes.length; i++) {
      if (pt.indexOf(excludedTypes[i]) !== -1) return true;
    }
    return false;
  }

  // ─── STYLES (messaggio servizio, CTA verde, prezzo in evidenza, 4 colonne) ───
  var css = `
    .wu-overlay { position:fixed; inset:0; z-index:999999; opacity:0; visibility:hidden; transition:opacity .25s ease, visibility .25s ease; }
    .wu-overlay.wu-open { opacity:1; visibility:visible; }
    .wu-backdrop { position:absolute; inset:0; background:rgba(0,0,0,.5); backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px); }
    @media (min-width:${MOBILE_BP}px) {
      .wu-panel { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%) scale(.96); opacity:0; background:#fff; border-radius:16px; width:680px; max-width:calc(100vw - 40px); max-height:calc(100vh - 40px); overflow:hidden; box-shadow:0 28px 64px rgba(0,0,0,.22),0 0 0 1px rgba(0,0,0,.06); transition:transform .35s cubic-bezier(.16,1,.3,1),opacity .3s ease; display:flex; flex-direction:column; }
      .wu-open .wu-panel { transform:translate(-50%,-50%) scale(1); opacity:1; }
      .wu-m-handle { display:none; }
    }
    @media (max-width:${MOBILE_BP - 1}px) {
      .wu-panel { position:absolute; bottom:0; left:0; right:0; background:#fff; border-radius:16px 16px 0 0; max-height:90vh; overflow:hidden; display:flex; flex-direction:column; box-shadow:0 -8px 40px rgba(0,0,0,.18); transform:translateY(100%); opacity:0; transition:transform .35s cubic-bezier(.16,1,.3,1),opacity .25s ease; }
      .wu-open .wu-panel { transform:translateY(0); opacity:1; }
      .wu-m-handle { display:flex; justify-content:center; padding:12px 0 6px; cursor:grab; flex-shrink:0; }
      .wu-m-handle span { width:40px; height:4px; border-radius:4px; background:#ddd; }
    }
    .wu-scroll { overflow-y:auto; -webkit-overflow-scrolling:touch; flex:1; padding:20px 24px 8px; }
    @media (max-width:${MOBILE_BP - 1}px) { .wu-scroll { padding:8px 18px 16px; } }
    .wu-hero { text-align:center; padding:8px 0 16px; }
    .wu-headline { margin:0 0 14px; font-size:clamp(15px,2.5vw,18px); font-weight:800; color:#111; text-transform:uppercase; letter-spacing:.04em; line-height:1.25; }
    .wu-shield-wrap { display:flex; justify-content:center; margin-bottom:4px; }
    .wu-shield-circle { width:86px; height:86px; border-radius:50%; background:linear-gradient(180deg,#e8f5e9,#c8e6c9); border:3px solid ${accentColor}; display:flex; flex-direction:column; align-items:center; justify-content:center; box-shadow:0 6px 20px rgba(11,93,30,.18); }
    .wu-shield-num { font-size:30px; font-weight:800; color:${accentColor}; line-height:1; }
    .wu-shield-label { font-size:9px; font-weight:800; letter-spacing:.12em; color:${accentEnd}; margin-top:2px; }
    .wu-rule { border:0; border-top:1px solid #e3e3e3; margin:0 0 18px; }
    .wu-pitch { margin:0 0 18px; font-size:14px; line-height:1.55; color:#444; text-align:center; }
    .wu-priceblock { text-align:center; margin-bottom:16px; }
    .wu-price-lead { display:block; font-size:13px; font-style:italic; color:${priceLeadColor}; margin-bottom:2px; }
    .wu-pr-v { font-size:clamp(28px,5vw,36px); font-weight:800; color:${priceColor}; letter-spacing:-.02em; }
    .wu-btn-y { width:100%; padding:16px 18px; background:${ctaFill}; color:${ctaFg}; border:none; border-radius:10px; font-size:14px; font-weight:800; text-transform:uppercase; letter-spacing:.06em; cursor:pointer; transition:transform .15s ease,filter .15s ease,box-shadow .15s ease; box-shadow:0 4px 16px rgba(11,93,30,.28); }
    .wu-btn-y:hover { filter:brightness(1.05); transform:translateY(-1px); box-shadow:0 6px 22px rgba(11,93,30,.35); }
    .wu-btn-y:active { transform:translateY(0); }
    .wu-btn-y:disabled { opacity:.65; cursor:wait; transform:none; filter:none; }
    .wu-feats { display:grid; grid-template-columns:repeat(4,1fr); gap:14px 12px; margin:20px 0 0; }
    @media (max-width:${MOBILE_BP - 1}px) { .wu-feats { grid-template-columns:repeat(2,1fr); gap:14px 10px; margin-top:14px; } }
    .wu-fcol { text-align:center; }
    .wu-fcol-ic { font-size:26px; line-height:1; display:block; margin-bottom:8px; }
    .wu-fcol-h { font-size:12px; font-weight:700; color:${featureTitleColor}; line-height:1.3; margin-bottom:6px; }
    .wu-fcol-t { font-size:11px; color:#666; line-height:1.4; }
    .wu-btn-n { width:100%; padding:10px 12px 4px; background:none; color:#888; border:none; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.04em; text-decoration:underline; text-underline-offset:3px; cursor:pointer; transition:color .15s ease; }
    @media (max-width:${MOBILE_BP - 1}px) { .wu-btn-n { padding:8px 12px 2px; margin-top:2px; } }
    .wu-btn-n:hover { color:#333; }
    .wu-legal { flex-shrink:0; background:#111; color:rgba(255,255,255,.88); font-size:9px; line-height:1.45; padding:12px 20px 14px; text-align:center; }
    .wu-legal:empty { display:none; }
    .wu-x { position:absolute; top:14px; right:14px; z-index:3; width:40px; height:40px; padding:0; border:1px solid rgba(0,0,0,.08); border-radius:50%; background:#fff; color:#4a4a4a; cursor:pointer; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 10px rgba(0,0,0,.07); transition:background .2s ease,border-color .2s ease,color .2s ease,transform .2s ease,box-shadow .2s ease; }
    .wu-x svg { display:block; flex-shrink:0; pointer-events:none; }
    .wu-x:hover { background:rgba(11,93,30,.07); border-color:rgba(11,93,30,.22); color:${accentColor}; box-shadow:0 4px 14px rgba(11,93,30,.12); transform:scale(1.04); }
    .wu-x:active { transform:scale(0.96); }
    @media (max-width:${MOBILE_BP - 1}px) { .wu-x { top:10px; right:12px; width:38px; height:38px; } .wu-btn-y{font-size:13px;padding:15px;margin-bottom:0} }
    .wu-notif { position:fixed; z-index:1000000; left:50%; transform:translateX(-50%) translateY(16px); opacity:0; background:#1a1a1a; color:#fff; padding:12px 20px; border-radius:10px; font-size:14px; white-space:nowrap; box-shadow:0 8px 32px rgba(0,0,0,.2); transition:all .3s cubic-bezier(.16,1,.3,1); pointer-events:none; }
    @media (min-width:${MOBILE_BP}px) { .wu-notif{bottom:24px} }
    @media (max-width:${MOBILE_BP - 1}px) { .wu-notif{top:24px;bottom:auto} }
    .wu-notif.wu-show { opacity:1; transform:translateX(-50%) translateY(0); }
  `;
  document.head.appendChild(Object.assign(document.createElement('style'), { textContent: css }));

  // ─── DOM ───
  var overlay = document.createElement('div');
  overlay.className = 'wu-overlay';
  overlay.innerHTML =
    '<div class="wu-backdrop"></div>' +
    '<div class="wu-panel">' +
      '<button type="button" class="wu-x" id="wu-close" aria-label="Chiudi">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path stroke="currentColor" stroke-width="2.25" stroke-linecap="round" d="M7 7l10 10M17 7L7 17"/>' +
        '</svg>' +
      '</button>' +
      '<div class="wu-m-handle"><span></span></div>' +
      '<div class="wu-scroll">' +
        '<header class="wu-hero">' +
          '<h2 class="wu-headline" id="wu-headline"></h2>' +
          '<div class="wu-shield-wrap">' +
            '<div class="wu-shield-circle">' +
              '<span class="wu-shield-num" id="wu-shield-num"></span>' +
              '<span class="wu-shield-label">ANNI</span>' +
            '</div>' +
          '</div>' +
        '</header>' +
        '<hr class="wu-rule" />' +
        '<p class="wu-pitch" id="wu-pitch"></p>' +
        '<div class="wu-priceblock">' +
          '<span class="wu-price-lead" id="wu-price-lead"></span>' +
          '<div class="wu-pr-v" id="wu-pr"></div>' +
        '</div>' +
        '<button type="button" class="wu-btn-y" id="wu-y"></button>' +
        '<button type="button" class="wu-btn-n" id="wu-n">' + esc(settings.decline_text || 'No grazie, procedi senza garanzia estesa') + '</button>' +
        '<div class="wu-feats" id="wu-feats"></div>' +
      '</div>' +
      '<div class="wu-legal" id="wu-legal"></div>' +
    '</div>';
  document.body.appendChild(overlay);

  var panel = overlay.querySelector('.wu-panel');
  var scrollEl = panel.querySelector('.wu-scroll');
  var $ = function(id) { return document.getElementById(id); };

  var pendingVid = null, pendingWid = null, pendingQty = 1;

  // Swipe (scroll su .wu-scroll, non sul panel)
  var drag = { sy:0, cy:0, on:false };
  panel.addEventListener('touchstart', function(e) {
    if (!isMobile()) return;
    var t=e.touches[0], r=panel.getBoundingClientRect();
    var st = scrollEl ? scrollEl.scrollTop : 0;
    if (t.clientY-r.top>60 && st>0) return;
    drag.sy=t.clientY; drag.on=true; panel.style.transition='none';
  }, {passive:true});
  panel.addEventListener('touchmove', function(e) {
    if (!drag.on) return; drag.cy=e.touches[0].clientY;
    var d=drag.cy-drag.sy; if(d>0) panel.style.transform='translateY('+d+'px)';
  }, {passive:true});
  panel.addEventListener('touchend', function() {
    if (!drag.on) return; drag.on=false; panel.style.transition='';
    if (drag.cy-drag.sy>100) doDecline(); else panel.style.transform='';
  }, {passive:true});

  function esc(s) { var d=document.createElement('div'); d.textContent=s; return d.innerHTML; }
  function fp(p) { return '€' + parseFloat(p).toFixed(2).replace('.',','); }
  // Segnaposto [[CHIAVE]]: in .liquid NON usare {{CHIAVE}} — Liquid li mangia prima del JS.
  function tmpl(str, map) {
    if (!str) return '';
    return String(str).replace(/\[\[(\w+)\]\]/g, function(_, k) { return map[k] != null ? map[k] : ''; });
  }

  function openPopup(tier, price, vid, qty) {
    pendingVid=vid; pendingWid=tier.variant_id; pendingQty=qty||1;
    var dur = tier.duration || '3 anni';
    var yearsNum = (String(dur).match(/^(\d+)/) || [, '3'])[1];
    var map = {
      DURATION: dur,
      YEARS_NUM: yearsNum,
      MAX_PRICE: fp(tier.max_price),
      PRODUCT_PRICE: fp(price)
    };
    $('wu-headline').textContent = settings.headline || 'Proteggi il tuo acquisto';
    $('wu-shield-num').textContent = yearsNum;
    var pitchSrc = tier.marketing_body || settings.marketing_body;
    if (!pitchSrc) {
      pitchSrc = 'Massimale [[MAX_PRICE]] per il tuo prodotto da [[PRODUCT_PRICE]]. Durata estensione: [[DURATION]].';
    }
    $('wu-pitch').textContent = tmpl(pitchSrc, map);
    $('wu-price-lead').textContent = settings.price_lead || 'con soli';
    $('wu-pr').textContent = fp(tier.price);
    $('wu-y').textContent = settings.accept_cta || 'Aggiungi garanzia';
    $('wu-y').disabled = false;

    var cols = tier.feature_columns || settings.feature_columns;
    if (!cols || !cols.length) {
      var feats = tier.features || [
        'Prosecuzione garanzia produttore per ' + dur,
        'Riparazione o sostituzione gratuita',
        'Massimale copertura ' + fp(tier.max_price),
        'Nessuna franchigia a carico del cliente'
      ];
      cols = feats.slice(0, 4).map(function(f) { return { title: f, text: '', icon: '✓' }; });
    }
    $('wu-feats').innerHTML = cols.map(function(c) {
      var title = tmpl(c.title || '', map);
      var text = tmpl(c.text || '', map);
      var ic = c.icon != null ? c.icon : '•';
      return (
        '<div class="wu-fcol">' +
          '<span class="wu-fcol-ic" aria-hidden="true">' + esc(ic) + '</span>' +
          '<div class="wu-fcol-h">' + esc(title) + '</div>' +
          (text ? '<div class="wu-fcol-t">' + esc(text) + '</div>' : '') +
        '</div>'
      );
    }).join('');

    var leg = settings.legal_footer ? tmpl(settings.legal_footer, map) : '';
    var legEl = $('wu-legal');
    if (leg) {
      legEl.textContent = leg;
      legEl.style.display = '';
    } else {
      legEl.textContent = '';
      legEl.style.display = 'none';
    }

    panel.style.transform = '';
    overlay.classList.add('wu-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('wu-open');
    document.body.style.overflow = '';
    setTimeout(function() { panel.style.transform=''; }, 350);
  }

  function notif(msg) {
    var n=document.createElement('div'); n.className='wu-notif'; n.textContent=msg;
    document.body.appendChild(n);
    requestAnimationFrame(function(){requestAnimationFrame(function(){n.classList.add('wu-show');});});
    setTimeout(function(){n.classList.remove('wu-show');setTimeout(function(){n.remove();},300);},2500);
  }

  // Section ID del cart drawer
  // Fix: section ID rilevata dinamicamente dal DOM (evita drawer vuoto
  // se la sezione cart-drawer viene ricreata e cambia ID).
  var _cachedCartDrawerSection = null;
  function getCartDrawerSection() {
    if (_cachedCartDrawerSection) return _cachedCartDrawerSection;
    var el = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
    if (el) {
      _cachedCartDrawerSection = el.id.replace(/^shopify-section-/, '');
      return _cachedCartDrawerSection;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      var parent = cd.closest('[id^="shopify-section-"]');
      if (parent) {
        _cachedCartDrawerSection = parent.id.replace(/^shopify-section-/, '');
        return _cachedCartDrawerSection;
      }
    }
    return null;
  }

  // Se l’add-to-cart era via fetch(FormData) del product-form, risolviamo la Promise che il tema attende
  var pendingCartAddFetchResolve = null;

  // Salva il fetch originale PRIMA di sovrascriverlo
  var origFetch = window.fetch.bind(window);

  // Allinea i <cart-count> dell’header (tema Hyper / FoxTheme) come product-form in theme.js
  function publishCartUpdateFromServer(done) {
    var ft = window.FoxTheme;
    var url = ft && ft.routes && ft.routes.cart_url ? ft.routes.cart_url : '/cart.js';
    var opts =
      ft && ft.utils && typeof ft.utils.fetchConfig === 'function'
        ? Object.assign({}, ft.utils.fetchConfig())
        : { headers: { Accept: 'application/json' }, method: 'GET' };
    origFetch(url, opts)
      .then(function(r) { return r.json(); })
      .then(function(cartJson) {
        if (ft && ft.pubsub && ft.pubsub.publish && ft.pubsub.PUB_SUB_EVENTS) {
          ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
        if (done) done();
      })
      .catch(function() { if (done) done(); });
  }

  function refreshAndOpenDrawer() {
    var sectionId = getCartDrawerSection();
    if (!sectionId) {
      var drawer0 = document.querySelector('cart-drawer');
      if (drawer0 && typeof drawer0.show === 'function') drawer0.show();
      return;
    }
    origFetch('/?sections=' + sectionId)
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var drawerHtml = sections[sectionId];
        if (drawerHtml) {
          var container = document.getElementById('shopify-section-' + sectionId);
          if (container) container.innerHTML = drawerHtml;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      })
      .catch(function() { window.location.reload(); });
  }

  function addToCart(items, cb) {
    origFetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items}) })
    .then(function(r){ return r.json(); })
    .then(function(d){
      if (d && d.status) {
        if (cb) cb(d);
        return;
      }
      publishCartUpdateFromServer(function() { if (cb) cb(d); });
    })
    .catch(function(){ window.location.reload(); });
  }

  function applyAfterAdd(d) {
    if (pendingCartAddFetchResolve) {
      var res = pendingCartAddFetchResolve;
      pendingCartAddFetchResolve = null;
      try {
        res(d);
      } catch (e) {}
    } else {
      refreshAndOpenDrawer();
    }
  }

  // Registra negli attributi del carrello quale prodotto copre la garanzia
  // appena aggiunta: la riga garanzia resta raggruppata, ma warranty-upsell-cart.js
  // sa cosa togliere quando il prodotto esce dal carrello.
  function registraLegame(variantProdotto, variantGaranzia) {
    if (typeof window.__warrantyRegistraLegame === 'function') {
      return window.__warrantyRegistraLegame(variantProdotto, variantGaranzia);
    }
    // sulla scheda prodotto lo script del carrello puo' non essere ancora
    // arrivato: in quel caso si scrive l'attributo qui, con la stessa chiave.
    window.__svcCartChain = (window.__svcCartChain || Promise.resolve())
      .then(function () {
        return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var mappa = {};
            var grezzo = (cart.attributes && cart.attributes._wu_map) || '';
            if (grezzo) { try { mappa = JSON.parse(grezzo) || {}; } catch (e) { mappa = {}; } }
            mappa[String(variantProdotto)] = String(variantGaranzia);
            return origFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { _wu_map: JSON.stringify(mappa) } })
            });
          });
      })
      .catch(function () {});
    return window.__svcCartChain;
  }

  function doAccept() {
    $('wu-y').disabled=true; $('wu-y').textContent=settings.adding_text || 'Aggiungendo...';
    addToCart([{id:parseInt(pendingVid,10),quantity:pendingQty},{id:parseInt(pendingWid,10),quantity:pendingQty}], function(d){
      registraLegame(pendingVid, pendingWid);
      closePopup();
      applyAfterAdd(d);
    });
  }

  function doDecline() {
    closePopup();
    addToCart([{id:parseInt(pendingVid,10),quantity:pendingQty}], function(d){
      applyAfterAdd(d);
    });
  }

  // Usa onclick diretto (addEventListener si perde dopo section render)
  $('wu-y').onclick = function(e) { e.stopPropagation(); doAccept(); };
  $('wu-n').onclick = function(e) { e.stopPropagation(); doDecline(); };
  $('wu-close').onclick = function(e) { e.stopPropagation(); doDecline(); };

  // Event delegation sull'overlay per il backdrop click
  overlay.onclick = function(e) {
    if (e.target === overlay.querySelector('.wu-backdrop')) doDecline();
  };

  document.addEventListener('keydown', function(e){ if(e.key==='Escape'&&overlay.classList.contains('wu-open')) doDecline(); });

  // ─── INTERCEPT ───
  function getPrice() {
    if (window.__warrantyProductPrice != null && window.__warrantyProductPrice !== '') {
      var wp = parseFloat(window.__warrantyProductPrice);
      if (!isNaN(wp) && wp > 0) return wp;
    }
    var el = document.querySelector('[data-product-price]');
    if (el) {
      var c = parseFloat(el.getAttribute('data-product-price')) / 100;
      if (!isNaN(c) && c > 0) return c;
    }
    var sel = '.product__price .price-item--regular,.product-single__price,.product__price .money,[data-product-price-current]';
    el = document.querySelector(sel);
    if (el) {
      var t = el.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
      var p = parseFloat(t);
      if (!isNaN(p) && p > 0) return p;
    }
    return 0;
  }
  function getType() { return window.__warrantyProductType || ''; }

  function logSkip(reason, detail) {
    if (!window.__warrantyUpsellDebug || !window.__warrantyUpsellDebug.eligible) return;
    console.warn('[WarrantyUpsell] Popup non mostrato:', reason, detail != null ? detail : '');
  }

  function isProductCartForm(form) {
    if (!form || String(form.tagName).toLowerCase() !== 'form') return false;
    var act = (form.getAttribute('action') || '').toLowerCase();
    if (act.indexOf('/cart/add') !== -1) return true;
    if (form.getAttribute('is') === 'product-form') return true;
    return false;
  }

  /** Ritorna { tier, price, vid, qty } o null. vid stringa variant id. */
  function evaluateUpsellForVariant(vid, qty) {
    if (!vid) return null;
    vid = String(vid);
    var q = parseInt(qty, 10);
    if (isNaN(q) || q < 1) q = 1;
    if (warrantyVariantIds.has(vid)) return null;
    var price = getPrice();
    var type = getType();
    if (isExcluded(type, vid)) {
      logSkip('tipo prodotto escluso o variant garanzia', { type: type, variantId: vid });
      return null;
    }
    if (price <= 0) {
      logSkip('prezzo = 0 (variante / __warrantyProductPrice / DOM)', { price: price });
      return null;
    }
    if (price < (config.min_price || 0)) {
      logSkip('prezzo sotto la soglia minima della garanzia (min_price)', price);
      return null;
    }
    var tier = findTier(price);
    if (!tier) {
      logSkip('prezzo sopra l’ultima fascia max_price dei tier', price);
      return null;
    }
    return { tier: tier, price: price, vid: vid, qty: q };
  }

  if (window.__warrantyUpsellDebug && window.__warrantyUpsellDebug.eligible) {
    console.log('[WarrantyUpsell] Upsell attivo. Tag atteso:', window.__warrantyUpsellDebug.matchedTag, '| Tag prodotto:', window.__warrantyUpsellDebug.productTags);
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!isProductCartForm(form)) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var hit = evaluateUpsellForVariant(idInput.value, form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value);
    if (!hit) return;
    e.preventDefault();
    e.stopPropagation();
    openPopup(hit.tier, hit.price, hit.vid, hit.qty);
  }, true);

  // Alcuni browser (estensioni) rendono window.fetch di sola lettura: l'assegnazione
  // lancia e si porterebbe via tutto il resto dello script. Senza patch si va avanti lo stesso.
  var fetchPatch = function(input, init) {
    var urlStr = typeof input === 'string' ? input : input && input.url != null ? String(input.url) : '';
    if (urlStr.indexOf('/cart/add') === -1) return origFetch.apply(this, arguments);
    var opts = init;
    if (typeof Request !== 'undefined' && input instanceof Request && !init) {
      return origFetch.apply(this, arguments);
    }
    if (!opts || opts.body == null) return origFetch.apply(this, arguments);

    var hit = null;

    if (typeof FormData !== 'undefined' && opts.body instanceof FormData) {
      var fd = opts.body;
      var rawId = fd.get('id');
      if (!rawId) return origFetch.apply(this, arguments);
      var rawQty = fd.get('quantity');
      hit = evaluateUpsellForVariant(String(rawId), rawQty);
    } else if (typeof opts.body === 'string') {
      try {
        var body = JSON.parse(opts.body);
        var items = body.items || [body];
        if (items.some(function(it) { return warrantyVariantIds.has(String(it.id)); })) return origFetch.apply(this, arguments);
        if (items.length !== 1 || !items[0].id) return origFetch.apply(this, arguments);
        hit = evaluateUpsellForVariant(String(items[0].id), items[0].quantity);
      } catch (ex) {
        return origFetch.apply(this, arguments);
      }
    } else {
      return origFetch.apply(this, arguments);
    }

    if (!hit) return origFetch.apply(this, arguments);

    return new Promise(function(resolve) {
      pendingCartAddFetchResolve = function(d) {
        resolve(new Response(JSON.stringify(d), { status: 200, headers: { 'Content-Type': 'application/json' } }));
      };
      openPopup(hit.tier, hit.price, hit.vid, hit.qty);
    });
  };
  try { window.fetch = fetchPatch; } catch (e) {
    try { Object.defineProperty(window, 'fetch', { value: fetchPatch, configurable: true, writable: true }); } catch (e2) { /* noop */ }
  }

  console.log('[WarrantyUpsell] v4 ready (' + tiers.length + ' tiers)');
})();